import React, { Component } from 'react';

import moment from 'moment';
import { Form, Row, Col, Input, Button, Modal, Select, DatePicker, message, Radio } from 'antd';
import { Message } from 'semantic-ui-react'

import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import RadioOperationMode from '../../../../../utils/RadioOperationMode';
import { RESTRICTION_TYPE_MAP } from '../../../../../utils/RestrictionTypeUtil';

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 14 },
};

const options = [
  { label: 'White List', value: true },
  { label: 'Black List', value: false },
];

// Restriction Type
const RestrictionTypeOptions = [];
for (let i = 0; i < RESTRICTION_TYPE_MAP.length; i++) {
  RestrictionTypeOptions.push(<Option key={RESTRICTION_TYPE_MAP[i].code}>{RESTRICTION_TYPE_MAP[i].label}</Option>);
}


class RestrictedAssetEditDialog extends Component {
  state = {
    
  };

  componentDidUpdate() {
    const { 
      createRestrictedAssetActionStatus,
      updateRestrictedAssetActionStatus,
    } = this.props;

    // 创建 Restricted Asset 成功
    if (createRestrictedAssetActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.loadRestrictedAsset();
      this.props.initCreateRestrictedAssetActionStatus();

      this.props.resetRestrictedAssetEditModalDialog();
    }
      
    // 创建 Restricted Asset 失败
    if (createRestrictedAssetActionStatus === ACTION_STATUS.ERROR) {
      this.props.initCreateRestrictedAssetActionStatus();
    }

    // 更新 Restricted Asset 成功
    if (updateRestrictedAssetActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.loadRestrictedAsset();
      this.props.initUpdateRestrictedAssetActionStatus();

      this.props.resetRestrictedAssetEditModalDialog();
    } 

    // 更新 Restricted Asset 失败
    if (updateRestrictedAssetActionStatus === ACTION_STATUS.ERROR) {
      this.props.initUpdateRestrictedAssetActionStatus();
    }
  }

  onInputChange = ({name, value}) => {
    this.props.restrictedAssetEditChangeInput({name, value});
  }

  assetClassOnChange = (value) => {
    this.props.restrictedAssetEditChangeInput({ name: 'assetClass', value });
  }

  instClassOnChange = (value) => {
    this.props.restrictedAssetEditChangeInput({ name: 'instClass', value });
  }

  fundCodeOnChange = (value) => {
    this.props.restrictedAssetEditChangeInput({ name: 'fundCode', value });

    if (!!value) {
      this.props.fundCodeSelectChanged(value);
    }
  }

  bookCodeOnChange = (value) => {
    this.props.restrictedAssetEditChangeInput({ name: 'bookCode', value });

    if (!!value) {
      this.props.bookCodeSelectChanged(value);
    }
  }

  radioGroupOnChanged = (e) => {
    this.props.restrictedAssetEditChangeInput({ name: 'isWhite', value: e.target.value });
  }

  // 提交数据
  submitButtonOnClicked = () => {
    const {
      restrictedAssetEditControlModal,
    } = this.props;

    const isAddMode = restrictedAssetEditControlModal.isAddMode;

    const {
      id,
      restrictionType,
      fundCode,
      bookCode,
      pmName,
      assetClass,
      instClass,
      explanation,
      kickOffDate,
      expiryDate,
      isWhite,
    } = restrictedAssetEditControlModal.fields;

    const form = this.props.form;

    // 表单校验
    form.validateFields((err) => {
        if (!err) {
          console.info('success');

          if (isAddMode) {
            this.props.createRestrictedAsset({
              id,
              restrictionType,
              fundCode,
              bookCode,
              pmName,
              assetClass,
              instClass,
              explanation,
              kickOffDate,
              expiryDate,
              isWhite,
            });
          } else {
            this.props.updateRestrictedAsset({
              id,
              restrictionType,
              fundCode,
              bookCode,
              pmName,
              assetClass,
              instClass,
              explanation,
              kickOffDate,
              expiryDate,
              isWhite,
            });
          }
        }
      },
    );
  }

  render() {
    const {
      restrictedAssetEditControlModal,
      
      // Fund Book Data
      fundCodeOptions,
      bookCodeOptions,

      // Asset Inst Class Data
      assetClassOptions,
      instClassOptions,

      createRestrictedAssetActionStatus,
      updateRestrictedAssetActionStatus,
    } = this.props;

    const {
      isOpened,
      isAddMode,
      respErrMsg,
    } = restrictedAssetEditControlModal;


    const { getFieldDecorator } = this.props.form;

    const {
      id,
      restrictionType,
      fundCode,
      bookCode,
      pmName,
      assetClass,
      instClass,
      explanation,
      kickOffDate,
      expiryDate,
      isWhite,
    } = restrictedAssetEditControlModal.fields;

    let modalTitle = "Edit Restricted Asset";
    if (isAddMode) {
      modalTitle = "Add Restricted Asset";
    }

    const isLoading = createRestrictedAssetActionStatus === ACTION_STATUS.LOGINING || updateRestrictedAssetActionStatus === ACTION_STATUS.LOGINING; 

    return (
      <div>
        <Modal
          title={modalTitle}
          centered
          width={1000}
          visible={isOpened}
          confirmLoading={isLoading}
          onOk={this.submitButtonOnClicked}
          onCancel={() => this.props.resetRestrictedAssetEditModalDialog()}
          destroyOnClose={true}
          maskClosable={false}
          okText="Submit"
          cancelText="Cancel"
        >
          <Form layout="horizontal">
            <Row gutter={24}>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Restriction Type">
                  {getFieldDecorator('restrictionType', {
                      initialValue: restrictionType,
                      rules: [{
                        required: true,
                        message: 'Please select restriction type',
                      }],
                    })(
                      <Select onChange={(value) => {
                            this.onInputChange({ name: 'restrictionType', value })
                          }} placeholder="Please Choose"
                        >
                        {RestrictionTypeOptions}
                      </Select>
                    )
                  }
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Fund">
                  {getFieldDecorator('fundCode', {
                      initialValue: fundCode,
                      rules: [{
                        required: true,
                        message: 'Please select fund',
                      }],
                    })(
                      <Select 
                        allowClear
                        showSearch
                        onChange={this.fundCodeOnChange} 
                        placeholder="Please Choose"
                        >
                        {fundCodeOptions}
                      </Select>
                    )
                  }
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Book">
                  {getFieldDecorator('bookCode', {
                      initialValue: bookCode,
                      rules: [{
                        required: true,
                        message: 'Please select book',
                      }],
                    })(
                      <Select 
                        allowClear
                        showSearch
                        onChange={this.bookCodeOnChange} 
                        placeholder="Please Choose"
                        >
                        {bookCodeOptions}
                      </Select>
                    )
                  }
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem {...formItemLayout} label="PM Name">
                  <Input placeholder="" 
                    value={pmName}
                    disabled
                    onChange={(e) => {
                        this.onInputChange({ name: 'pmName', value: e.target.value })
                      }}
                  />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Asset Class">
                  {getFieldDecorator('assetClass', {
                      initialValue: assetClass,
                      rules: [{
                        required: true,
                        message: 'Please select Asset Class',
                      }],
                    })(
                      <Select 
                        allowClear
                        showSearch
                        onChange={this.assetClassOnChange} 
                        placeholder="Please Choose"
                        >
                        {assetClassOptions}
                      </Select>
                    )
                  }
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Inst Class">
                  {getFieldDecorator('instClass', {
                      initialValue: instClass,
                      rules: [{
                        required: true,
                        message: 'Please select Inst Class',
                      }],
                    })(
                      <Select 
                        allowClear
                        showSearch
                        onChange={this.instClassOnChange} 
                        placeholder="Please Choose"
                        >
                        {instClassOptions}
                      </Select>
                    )
                  }
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Explanation">
                  <TextArea placeholder="Explanation" 
                    value={explanation}
                    onChange={(e) => {
                        this.onInputChange({ name: 'explanation', value: e.target.value })
                      }}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Kick Off Date">
                  {getFieldDecorator('kickOffDate', {
                    initialValue: kickOffDate === '' ? null : moment(kickOffDate),
                    rules: [{
                      required: true,
                      message: 'Please select kick off date',
                    }],
                  })(
                    <DatePicker 
                      allowClear={false}
                      onChange={(date, dateString) => {
                        this.onInputChange({ name: 'kickOffDate', value: dateString });
                      }} />
                    )
                  }
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <FormItem {...formItemLayout} label="Expiry Date">
                  {getFieldDecorator('expiryDate', {
                    initialValue: expiryDate === '' ? null : moment(expiryDate),
                    rules: [{
                      required: true,
                      message: 'Please select expiry date',
                    }],
                  })(
                    <DatePicker 
                      allowClear={false}
                      onChange={(date, dateString) => {
                        this.onInputChange({ name: 'expiryDate', value: dateString });
                      }} 
                      />
                   )
                  } 
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem {...formItemLayout} label="List Type">
                  <Radio.Group options={options} defaultValue={isWhite} onChange={this.radioGroupOnChanged} />
                </FormItem>
              </Col>
            </Row>
          </Form>
          {
            !!respErrMsg &&  
            <Message negative>
              <Message.Header>Response Error Message</Message.Header>
            <p>{ respErrMsg }</p>
          </Message>
          }
        </Modal>
      </div>
    );
  }
}

const RestrictedAssetEditDialogForm = Form.create({ name: 'restricted_asset_edit_dialog' })(RestrictedAssetEditDialog);

export default RestrictedAssetEditDialogForm;